import _ from 'lodash';
import * as api from 'assets/js/api';

const state = {
  problem_requests: [],
  general_stats: {
    num_queries: 0,
    num_requests: 0,
  },
};

const NUM_CALL_THRESHOLD = 40;
const NUM_REPEAT_THRESHOLD = 10;
const QUERY_DUR_THRESHOLD = 0.3;

const actions = {
  RecordDeveloperStats({ commit, stateArg }, payload) {
    // Extract statistics from developer stats.
    const db = _.get(payload, 'response.data.developer.database');
    const isQreserve = !!_.get(payload, 'response.data.developer');
    const req = { reasons: [],
      num_queries: 0,
      url: payload.url,
      opts: payload.opts,
      response: payload.response };
    let isProblem = false;
    if (db) {
      req.num_queries = db.num_calls;
      if (db.num_calls > NUM_CALL_THRESHOLD) {
        isProblem = true;
        req.reasons.push('Too many queries');
      }
      if (db.slow_calls &&
        _.some(db.slow_calls, (sc) => sc.dur > QUERY_DUR_THRESHOLD)) {
        isProblem = true;
        req.reasons.push('Slow queries');
      }
      if (db.high_repeats &&
        _.some(db.high_repeats, (hr) => hr[0] > NUM_REPEAT_THRESHOLD)) {
        isProblem = true;
        req.reasons.push('High repeats');
      }
      if (isProblem) {
        commit('ADD_PROBLEM_REQUEST', req);
      }
      commit('INCREASE_NUM_QUERIES', db.num_calls);
    }

    if (isQreserve) {
      commit('INCREASE_NUM_REQUESTS', 1);
    }
  },

  ClearDeveloperStats({ commit, stateArg }) {
    commit('CLEAR_STATISTICS');
  },
};

const mutations = {
  ADD_PROBLEM_REQUEST(stateArg, request) {
    const stateCopy = stateArg;
    stateCopy.problem_requests.push(request);
  },
  CLEAR_STATISTICS(stateArg) {
    const stateCopy = stateArg;
    stateCopy.problem_requests = [];
    stateCopy.general_stats = { num_queries: 0, num_requests: 0 };
  },
  INCREASE_NUM_QUERIES(stateArg, numQueries) {
    const stateCopy = stateArg;
    stateCopy.general_stats.num_queries += numQueries;
  },
  INCREASE_NUM_REQUESTS(stateArg, numRequests) {
    const stateCopy = stateArg;
    stateCopy.general_stats.num_requests += numRequests;
  },
};

export default { actions, mutations, state };
